import { dateInputIsValid } from 'main/util/date'
import { IParams, IValidation } from './types'

export function initialParams(): IParams {
  return { birthday: '', desiredEnrollmentDate: '' }
}

export function validate(params: IParams) {
  const { birthday, desiredEnrollmentDate } = params
  const validation: IValidation = {}

  if (!birthday) {
    validation.birthday = 'Please enter a date of birth'
  } else if (!dateInputIsValid(birthday)) {
    validation.birthday = 'Please enter a valid date (mm/dd/yyyy)'
  }

  if (!desiredEnrollmentDate) {
    validation.desiredEnrollmentDate = 'Please enter a desired start date'
  } else if (!dateInputIsValid(desiredEnrollmentDate)) {
    validation.desiredEnrollmentDate = 'Please enter a valid date (mm/dd/yyyy)'
  }

  return validation
}
